<template>
  <div>
    <v-tabs v-model="active" color="white" :slider-color="$store.state.theme.brand_color">
      <v-tab ripple :key="'applicants'" :href="'#applicants'">{{ $t('Applicants') }}</v-tab>
    </v-tabs>
    <v-container>
      <div>
        <h4>Applicants</h4>
        <div style="float: right">
          <v-btn @click="showFilter = true" depressed color="primary">
            <em class="fas fa-search mr-1" /> {{ $t('search') }}</v-btn
          >
          <v-btn
            :loading="exportloading"
            @click="exportData"
            outline
            color="grey"
            class="ma-0 mb-0"
          >
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
          </v-btn>
        </div>
        <div class="text-xs-left pb-2">
          <Pagination
            :key="page"
            v-model="page"
            :limit="20"
            :total="total"
            @onChange="onChange($event)"
          >
          </Pagination>
        </div>

        <v-data-table
          expand
          hide-actions
          :loading="loading"
          :headers="headers"
          :items="data"
          class="elevation-1 scgallrenttable"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">
                <v-btn @click="showData(props.item)" outline icon>
                  <em style="font-size: large" class="far fa-user" />
                </v-btn>
              </td>
              <td class="text-xs-center">
                {{ props.item.first_name + ' ' + props.item.last_name }}
              </td>
              <td class="text-xs-left">
                <div class="pl-2 py-2">
                  <div style="font-weight: 900">
                    {{ props.item.educations[0].degree }}
                  </div>
                  <div>
                    {{ props.item.educations[0].university }}
                  </div>
                  <div style="color: #a5a5a5">
                    {{ props.item.educations[0].faculty }}
                  </div>
                  <div style="color: #a5a5a5">GPA {{ props.item.educations[0].GPAX }}</div>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-dialog v-model="dialogModal" width="600px">
          <v-card>
            <v-card-text>
              <div class="text-xs-right" style="float: right">
                <v-btn @click="closeDialog" icon>
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
              <div>
                <h5 class="mb-1">
                  {{ dialogData.first_name + ' ' + dialogData.last_name }}
                </h5>
              </div>
              <div class="mt-4">
                <div class="text-xs-center mb-3">
                  <v-avatar size="60" style="background-color: darkgrey">
                    <v-img :src="dialogData.profile_pic"></v-img>
                  </v-avatar>
                </div>
                <v-layout row wrap>
                  <v-flex xs6 class="mb-2">
                    <div class="caption grey--text">Nationality</div>
                    <div>{{ dialogData.nationality }}</div>
                  </v-flex>
                  <v-flex xs6 class="mb-2">
                    <div class="caption grey--text">Date of Birth</div>
                    <div>
                      {{ dialogData.dob | DateFormat('DD/MM/YYYY') }}
                      <span style="font-weight: bold">({{ ageCal(dialogData.dob) }})</span>
                    </div>
                  </v-flex>
                  <v-flex xs12 class="mb-2">
                    <div class="caption grey--text">Phone</div>
                    <div>{{ dialogData.phone_number }}</div>
                  </v-flex>
                  <v-flex xs6 class="mb-2">
                    <div class="caption grey--text">Email</div>
                    <div>{{ dialogData.email }}</div>
                  </v-flex>
                  <v-flex xs6 class="mb-2">
                    <div class="caption grey--text">Current Address</div>
                    <div>{{ dialogData.current_address }}</div>
                  </v-flex>
                  <v-flex xs6 class="mb-2">
                    <div class="caption grey--text">Location Interests</div>
                    <div>{{ dialogData.location_interest }}</div>
                  </v-flex>
                  <v-flex xs6 class="mb-2">
                    <div class="caption grey--text">Place of Birth</div>
                    <div>{{ dialogData.place_of_birth }}</div>
                  </v-flex>
                  <v-flex xs6 class="mb-2">
                    <div class="caption grey--text">Job Interests</div>
                    <div style="font-weight: bold">
                      {{ jobinterestFormat(dialogData.job_interest) }}
                    </div>
                  </v-flex>
                </v-layout>
                <v-btn @click="openLink(dialogData.resume)" outline block color="grey"
                  >Resume</v-btn
                >
                <div>
                  <h6 style="font-weight: 500">Experience</h6>

                  <div v-if="dialogData.work_experiences && dialogData.work_experiences.length">
                    <div
                      v-for="(work, k) in dialogData.work_experiences"
                      :key="'work__' + k"
                      class="pl-2 py-2"
                    >
                      <v-card>
                        <v-card-text>
                          <div style="font-weight: 900">
                            {{ work.company }}
                          </div>
                          <div>
                            {{ work.position }}
                          </div>
                          <div style="color: #a5a5a5">
                            {{ work.salary }}
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </div>
                  <div v-else>
                    <div class="pl-2 py-2">
                      <v-card>
                        <v-card-text>
                          <div style="font-weight: 900" class="text-xs-center">ไม่มีประสบการณ์</div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </div>
                  <h6 style="font-weight: 500">Education</h6>
                  <div>
                    <div
                      v-for="(edu, k) in dialogData.educations"
                      :key="'edu__' + k"
                      class="pl-2 py-2"
                    >
                      <v-card>
                        <v-card-text>
                          <div style="font-weight: 900">
                            {{ edu.degree }}
                          </div>
                          <div>
                            {{ edu.university }}
                          </div>
                          <div style="color: #a5a5a5">
                            {{ edu.faculty }}
                          </div>
                          <div style="color: #a5a5a5">GPA {{ edu.GPAX }}</div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="showFilter" width="600px">
          <v-card>
            <v-card-text>
              <div class="text-xs-right">
                <v-icon @click="showFilter = false">close</v-icon>
              </div>
              <div>
                <v-layout row wrap>
                  <v-flex xs6 class="form-control px-1">
                    <label>First name</label>
                    <input v-model="filter.first_name" placeholder="First name" type="text" />
                  </v-flex>
                  <v-flex xs6 class="form-control px-1">
                    <label>Last name</label>
                    <input v-model="filter.last_name" placeholder="Last name" type="text" />
                  </v-flex>
                  <v-flex xs6 class="form-control px-1">
                    <label>Location interest</label>
                    <multiselect
                      placeholder="Location interest"
                      v-model="filter.location_interest"
                      :options="location_interests"
                      :searchable="false"
                    ></multiselect>
                  </v-flex>
                  <v-flex xs6 class="form-control px-1">
                    <label>Job interest</label>
                    <multiselect
                      placeholder="Job interest"
                      :searchable="false"
                      v-model="filter.job_interest"
                      :options="jobs"
                    ></multiselect>
                    <!-- :allow-empty="true" :searchable="false" selectLabel selectedLabel deselect-label
                    track-by="label" -->
                  </v-flex>
                  <v-flex xs6 class="form-control px-1">
                    <label>Nationality</label>
                    <multiselect
                      placeholder="Nationality"
                      v-model="filter.nationality"
                      :options="nationalities"
                      :searchable="true"
                    ></multiselect>
                  </v-flex>
                  <v-flex xs6 class="form-control px-1">
                    <label>Email</label>
                    <input v-model="filter.email" placeholder="Email" type="text" />
                  </v-flex>
                  <v-flex xs6 class="form-control px-1">
                    <label>Phone</label>
                    <input v-model="filter.phone_number" placeholder="Phone" type="text" />
                  </v-flex>

                  <v-flex xs6 class="form-control px-1">
                    <label>Educations</label>
                    <multiselect
                      placeholder="Educations"
                      v-model="filter.educations"
                      :options="degreesOptions"
                      :searchable="true"
                    ></multiselect>
                  </v-flex>
                  <v-flex xs6 class="form-control px-1">
                    <label>Work experiences</label>
                    <multiselect
                      placeholder="Work experiences"
                      v-model="filter.work_experiences"
                      :options="workOptions"
                      :searchable="true"
                    ></multiselect>
                  </v-flex>
                </v-layout>
              </div>
              <div class="text-xs-center">
                <v-btn @click="clearSearch" color="grey" outline>{{ $t('clear') }}</v-btn>
                <v-btn @click="onSearch" color="primary" depressed>{{ $t('search') }}</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Pagination from '@/components/elements/Pagination.vue'
import api from '@/api'
import moment from 'moment'
import XLSX from 'xlsx'
import Multiselect from 'vue-multiselect'

export default {
  computed: {
    ...mapGetters(['selectedBot'])
  },
  components: {
    Pagination,
    Multiselect
  },
  data() {
    return {
      workOptions: ['มีประสบการณ์', 'ไม่มีประสบการณ์'],
      jobs: [
        'Account&Audit',
        'Credit&Risk Management',
        'Investment Banking & Finance',
        'IT',
        'Legal&Compliance',
        'Marketing Product&Channel Management',
        'Overseas Branches',
        'Relationship Management'
      ],
      nationalities: [
        'Afghan',
        'Albanian',
        'Algerian',
        'American',
        'Andorran',
        'Angolan',
        'Antiguans',
        'Argentinean',
        'Armenian',
        'Australian',
        'Austrian',
        'Azerbaijani',
        'Bahamian',
        'Bahraini',
        'Bangladeshi',
        'Barbadian',
        'Barbudans',
        'Batswana',
        'Belarusian',
        'Belgian',
        'Belizean',
        'Beninese',
        'Bhutanese',
        'Bolivian',
        'Bosnian',
        'Brazilian',
        'British',
        'Bruneian',
        'Bulgarian',
        'Burkinabe',
        'Burmese',
        'Burundian',
        'Cambodian',
        'Cameroonian',
        'Canadian',
        'Cape Verdean',
        'Central African',
        'Chadian',
        'Chilean',
        'Chinese',
        'Colombian',
        'Comoran',
        'Congolese',
        'Costa Rican',
        'Croatian',
        'Cuban',
        'Cypriot',
        'Czech',
        'Danish',
        'Djibouti',
        'Dominican',
        'Dutch',
        'East Timorese',
        'Ecuadorean',
        'Egyptian',
        'Emirian',
        'Equatorial Guinean',
        'Eritrean',
        'Estonian',
        'Ethiopian',
        'Fijian',
        'Filipino',
        'Finnish',
        'French',
        'Gabonese',
        'Gambian',
        'Georgian',
        'German',
        'Ghanaian',
        'Greek',
        'Grenadian',
        'Guatemalan',
        'Guinea-Bissauan',
        'Guinean',
        'Guyanese',
        'Haitian',
        'Herzegovinian',
        'Honduran',
        'Hungarian',
        'I-Kiribati',
        'Icelander',
        'Indian',
        'Indonesian',
        'Iranian',
        'Iraqi',
        'Irish',
        'Israeli',
        'Italian',
        'Ivorian',
        'Jamaican',
        'Japanese',
        'Jordanian',
        'Kazakhstani',
        'Kenyan',
        'Kittian and Nevisian',
        'Kuwaiti',
        'Kyrgyz',
        'Laotian',
        'Latvian',
        'Lebanese',
        'Liberian',
        'Libyan',
        'Liechtensteiner',
        'Lithuanian',
        'Luxembourger',
        'Macedonian',
        'Malagasy',
        'Malawian',
        'Malaysian',
        'Maldivan',
        'Malian',
        'Maltese',
        'Marshallese',
        'Mauritanian',
        'Mauritian',
        'Mexican',
        'Micronesian',
        'Moldovan',
        'Monacan',
        'Mongolian',
        'Moroccan',
        'Mosotho',
        'Motswana',
        'Mozambican',
        'Namibian',
        'Nauruan',
        'Nepalese',
        'New Zealander',
        'Nicaraguan',
        'Nigerian',
        'Nigerien',
        'North Korean',
        'Northern Irish',
        'Norwegian',
        'Omani',
        'Pakistani',
        'Palauan',
        'Panamanian',
        'Papua New Guinean',
        'Paraguayan',
        'Peruvian',
        'Polish',
        'Portuguese',
        'Qatari',
        'Romanian',
        'Russian',
        'Rwandan',
        'Saint Lucian',
        'Salvadoran',
        'Samoan',
        'San Marinese',
        'Sao Tomean',
        'Saudi',
        'Scottish',
        'Senegalese',
        'Serbian',
        'Seychellois',
        'Sierra Leonean',
        'Singaporean',
        'Slovakian',
        'Slovenian',
        'Solomon Islander',
        'Somali',
        'South African',
        'South Korean',
        'Spanish',
        'Sri Lankan',
        'Sudanese',
        'Surinamer',
        'Swazi',
        'Swedish',
        'Swiss',
        'Syrian',
        'Taiwanese',
        'Tajik',
        'Tanzanian',
        'Thai',
        'Togolese',
        'Tongan',
        'Trinidadian or Tobagonian',
        'Tunisian',
        'Turkish',
        'Tuvaluan',
        'Ugandan',
        'Ukrainian',
        'Uruguayan',
        'Uzbekistani',
        'Venezuelan',
        'Vietnamese',
        'Welsh',
        'Yemenite',
        'Zambian',
        'Zimbabwean'
      ],
      location_interests: ['กรุงเทพ', 'ต่างจังหวัด'],
      genderOptions: ['ชาย', 'หญิง', 'อื่นๆ'],
      degreesOptions: [
        'มัธยมศึกษาตอนปลาย',
        'ประกาศนียบัตรวิชาชีพ (ปวช.)',
        'ประกาศนียบัตรวิชาชีพชั้นสูง (ปวส.)',
        'ปริญญาตรี',
        'ปริญญาโท',
        'ปริญญาเอก',
        'อื่นๆ'
      ],
      limit: 20,
      offset: 0,
      showFilter: false,
      exportloading: false,
      dialogModal: false,
      filter: {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        location_interest: '',
        job_interest: '',
        nationality: '',
        educations: '',
        gender: '',
        work_experiences: ''
      },
      dialogData: {},
      page: 1,
      total: 1,
      active: 'applicants',
      loading: false,
      headers: [
        { text: '', value: '', sortable: false, width: '1%' },
        { text: 'Name', value: 'first_name', align: 'center', width: '2%' },
        { text: 'Education', value: 'educations', align: 'left' }
      ],
      data: []
    }
  },
  async mounted() {
    await this.getData(20, 0)
  },
  ageCal() {
    if (this.input.dob) {
      return moment().diff(this.input.dob, 'years')
    } else return 0
  },
  methods: {
    openLink(url) {
      window.open(url, '_blank')
    },
    clearSearch() {
      this.filter = {
        first_name: '',
        nationality: '',
        last_name: '',
        email: '',
        gender: '',
        phone_number: '',
        location_interest: '',
        job_interest: '',
        educations: '',
        work_experiences: ''
      }
      this.onSearch()
    },
    onSearch() {
      this.showFilter = false
      this.getData(20, 0)
    },
    ageCal(dob) {
      if (dob) {
        return moment().diff(dob, 'years')
      } else return 0
    },
    async exportData() {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      let filename = 'applicantslist'

      var json = []

      vm.exportloading = true
      var response = await this.getData('none', 'none')
      if (response.data) {
        var data = response.data
      }

      json = data.map((el) => {
        return {
          Name: el.first_name ? el.first_name + ' ' + el.last_name : '-',
          'Date of Birth': el.dob
            ? `${moment(el.dob).format('DD/MM/YYYY')} (${this.ageCal(el.dob)})`
            : '-',
          Phone: el.phone_number ? el.phone_number : '-',
          Email: el.email ? el.email : '-',
          Nationality: el.nationality ? el.nationality : '-',
          'Current Address': el.current_address ? el.current_address : '-',
          'Location Interests': el.location_interest ? el.location_interest : '-',
          'Place of Birth': el.place_of_birth ? el.place_of_birth : '-',
          'Job Interests': el.job_interest ? el.job_interest.join(' / ') : '-',
          Experience: el.work_experiences
            ? el.work_experiences
                .map((val) => {
                  return `บริษัท${val.company} ตำแหน่ง${val.position} เงินเดือน${val.salary}`
                })
                .join(' / ')
            : '-',
          Education: el.educations
            ? el.educations
                .map((val) => {
                  return `${val.degree} ${val.university} ${val.faculty} GPA: ${val.GPAX}`
                })
                .join(' / ')
            : '-'
        }
      })

      var dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
      vm.exportloading = false
    },
    jobinterestFormat(val) {
      if (val && val.length) {
        return val.join(' / ')
      } else {
        return '-'
      }
    },
    showData(item) {
      this.dialogModal = true
      this.dialogData = item
    },
    closeDialog() {
      this.dialogModal = false
      this.dialogData = {}
    },
    async onChange(val) {
      var response = await this.getData(val.limit, val.offset)
    },

    getData(limit, offset) {
      var vm = this
      return new Promise((resolve) => {
        vm.loading = true
        var data = {
          pageid: vm.selectedBot.pageid // requied
        }
        Object.assign(data, vm.filter)
        if (limit !== 'none' && offset !== 'none') {
          Object.assign(data, {
            limit,
            offset
          })
        }
        api.bangkokbankapplicantall(data, (err, response) => {
          if (response.responsecode == 200) {
            if (limit !== 'none' && offset !== 'none') {
              vm.data = response.data ? response.data : []
            }
            vm.loading = false
            resolve(response)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/bblcareer/main.vue